@if (showModal) {
<app-dialog-title>{{ "remove-from-batch" | transloco }}</app-dialog-title>
<mat-dialog-content class="content filter-item">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (!errorMessage && bulkActionState !== 'COMPLETED') {
  <div>
    <p>
      You are about to remove {{ selectedTaxReturnIds.length }}
      {{ taxReturnAlias
      }}{{ selectedTaxReturnIds.length === 1 ? "" : "s" }} from the selected
      batch.
    </p>
    <p>{{ "are-you-sure-you-want-to-proceed" | transloco }}</p>
  </div>
  } @if (bulkActionState === 'COMPLETED') {
  <div>
    <p>
      {{ taxReturnAlias }}{{ selectedTaxReturnIds.length === 1 ? "" : "s" }}
      {{ "removed-from-the-batch" | transloco }}
    </p>
    <p>
      {{
        "important-make-sure-you-generate-the-draft-package-again-for-this-batch"
          | transloco
      }}
    </p>
  </div>
  }
</mat-dialog-content>
@if (bulkActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="removeFromBatch()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: bulkActionState === 'LOADING' }"
  >
    {{ "remove-from-batch" | transloco }}
  </button>
</mat-dialog-actions>
} @if (bulkActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
